import { Breadcrumb, Card } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';

const NetherCalc: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>
                    Cinverse Website - Tools Nether Calc
                </title>
            </Helmet>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item>Tools</Breadcrumb.Item>
                <Breadcrumb.Item>Nether Calc</Breadcrumb.Item>
            </Breadcrumb>
            <Card>
                Ini Pages Untuk Tools Nether Calc
            </Card>
        </>
    );
};

export default NetherCalc;
